exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container .tab-nav[data-v-2d794f52]{margin-bottom:.5rem;padding-top:2rem}.container .tab-containt[data-v-2d794f52]{height:0;overflow:hidden}.container .tab-containt.active[data-v-2d794f52]{height:auto}", ""]);

// exports
